import vuerouter from "vue-router";
import Calendario from "./views/Calendario.vue";
import BibliotecaDigital from "./views/BibliotecaDigital.vue";
import AdministracionBibliotecaDigitalVue from "../Prospecto/views/AdministracionBibliotecaDigital.vue";
import EdicionRecursoBibliotecaDigitalVue from "../Prospecto/views/EdicionRecursoBibliotecaDigital.vue";

const rutasMaster = (vuerouter.RouteRecordRaw = [
  {
    name: "Calendario",
    path: "Calendario",
    component: Calendario
  },
  {
    name: "BibliotecaDigital",
    path: "BibliotecaDigital",
    component: BibliotecaDigital
  },
  {
    name: "AdministracionBibliotecaDigital",
    path: "administracion-biblioteca",
    component: AdministracionBibliotecaDigitalVue,
  },
  {
    name: "EdicionRecurso",
    path: "edicion-recurso",
    component: EdicionRecursoBibliotecaDigitalVue,
  }
]);

export default rutasMaster;
